// Resolves an image URL. If it starts with "/api/" it prepends REACT_APP_BACKEND_URL.
// Otherwise it returns the URL as-is (external URLs like https://jilongot.com/...).
export const resolveImageUrl = (url) => {
  if (!url) return '';
  if (typeof url !== 'string') return '';
  if (url.startsWith('/api/')) {
    const base = process.env.REACT_APP_BACKEND_URL || '';
    return `${base}${url}`;
  }
  return url;
};
